export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Repetir operação"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Histórico de operações"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lista de contas"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erro desconhecido"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lista de tokens"])}
}